import { Component, Input, Output, EventEmitter } from "@angular/core";
import { LanguageService } from "../../services/language.service";

@Component({
  selector: "app-search-popup",
  templateUrl: "./search-popup.component.html",
  styleUrls: ["./search-popup.component.css"]
})
export class SearchPopupComponent {
  @Input() popupVisible = false;
  @Input() searchVisible = true;
  @Input() closeAfterSearch = true;
  @Input() title: string;
  @Input() fullScreen = false;
  @Input() width: number;
  @Input() height: number;
  @Input() isBusy = false;

  @Output() searchClicked = new EventEmitter<void>();
  @Output() closeClicked = new EventEmitter<void>();

  constructor(public languageService: LanguageService) {}

  onSearch() {
    this.searchClicked.emit();
    if (!this.closeAfterSearch) { return; }
    this.closeClicked.emit();
  }
}
